import Main from './Main'
import Lista from './components/TipoDevolucaoLista'
import Novo from './components/NovoTipoDevolucao'

export default [
  {
    path: 'tipo-devolucao',
    name: 'policiacivil.processo.tipo-devolucao',
    component: Main,
    redirect: { name: 'policiacivil.processo.tipo-devolucao.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.tipo-devolucao.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.tipo-devolucao.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.tipo-devolucao.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/tipo-devolucao/routes.js